var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 3c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7.2a2 2 0 0 1-2 2h-1.2v3.2l-3.6-3.2H3a2 2 0 0 1-2-2V3ZM5.4 5h7.2M5.4 8.2h4.8",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgComment;